<template>
  <div>
    <v-card style="margin-left:1px; margin-right:1px;">
      <v-card-title class="text-h6 blue darken-1 lighten-2 py-2">
        <v-row no-gutters>
          <v-col cols="12">
            <div class="h6" style="color:white!important;">
              <v-icon color="white">mdi-format-list-bulleted-type</v-icon>
              Preguntas
            </div>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row class="mx-2 mt-2">
          <v-col class="text-left" cols="12" md="6">
            <dialog-form-pregunta :id-accion="1" :id-encuesta-prop="idEncuesta" :id-seccion-prop="idSeccion" :fn-on-save="obtenerPreguntasBySeccion" :lst-grupos="lstGrupos" :lstPreguntas="lstPreguntas"></dialog-form-pregunta>
          </v-col>
          <v-col class="text-right" cols="12" md="6">
            <dialog-ordenar-preguntas :lst-preguntas="lstPreguntas" :fn-on-save="obtenerPreguntasBySeccion"></dialog-ordenar-preguntas>
          </v-col>
        </v-row>

        <v-row class="mx-2 mt-2">
          <v-col v-if="loadingComp" class="text-center" cols="12">
            <v-skeleton-loader type="image" />
          </v-col>
          <v-col v-else class="text-center" cols="12">
            <v-alert 
              v-if="lstPreguntas.length == 0"
              type="info">
              No se han encontrado preguntas para esta sección.
            </v-alert>

            <v-expansion-panels
              v-model="panel"
              multiple
              inset
            >
              <v-expansion-panel
                v-for="(item,i) in lstPreguntas"
                :key="i"
              >
                <v-expansion-panel-header v-slot="{ open }">
                  <v-row no-gutters>
                    <v-col :cols="open ? 10 : 8" style="margin: auto 0">
                      <v-avatar
                        class="mr-2"
                        color="teal"
                        size="25px"
                        dark
                        style="color:white"
                      >
                        {{i+1}}
                      </v-avatar>
                      <strong v-html="item.nombrePregunta"></strong>
                    </v-col>
                    <v-col
                      v-if="!open"
                      cols="2"
                      class="text--secondary text-center"
                    >
                      <v-fade-transition leave-absolute>
                        <v-row
                          no-gutters
                          style="width: 100%"
                        >
                          <v-col cols="12">
                            <v-icon>{{item.idCatTipoPreguntaNavigation.icono}}</v-icon>
                            {{item.idCatTipoPreguntaNavigation.tipoPregunta}}
                          </v-col>
                        </v-row>
                      </v-fade-transition>
                    </v-col>
                    <v-col
                      cols="2"
                      class="text--secondary text-center"
                    >
                      <v-fade-transition leave-absolute>
                        <v-row
                          no-gutters
                          style="width: 100%"
                        >
                          <v-col cols="12">
                            <dialog-form-pregunta :id-accion="2" :id-encuesta-prop="idEncuesta" :id-seccion-prop="idSeccion" :obj-pregunta="item" :fn-on-save="obtenerPreguntasBySeccion" :lst-grupos="lstGrupos" :lstPreguntas="lstPreguntas" :button-size-small="true" :icono="true"></dialog-form-pregunta>
                            <dialog-eliminar-pregunta :id-pregunta="item.idPregunta" :obj-pregunta="item" :fn-on-save="obtenerPreguntasBySeccion" :button-size-small="true" :icono="true"></dialog-eliminar-pregunta>
                          </v-col>
                        </v-row>
                      </v-fade-transition>
                    </v-col>
                  </v-row>
                </v-expansion-panel-header>
                <v-expansion-panel-content>

                  <pregunta-seccion-encuesta-content :item="item"></pregunta-seccion-encuesta-content>
                  
                  <v-row v-if="item.idCatTipoPregunta == 3 || item.idCatTipoPregunta == 4  || item.idCatTipoPregunta == 7">
                    <v-col cols="12">
                      <respuestas-preg-sec-enc 
                        :id-seccion="idSeccion"
                        :id-pregunta="item.idPregunta" 
                        :lst-respuestas="item.eiCatRespuesta"
                        :fn-set-respuestas-pregunta="fnSetRespuestas"
                      >
                      </respuestas-preg-sec-enc>
                    </v-col>
                  </v-row>

                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>

          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import{ getPreguntasBySeccion } from "@/api";

export default {
  name: "PreguntasSeccionEncuesta",
  components: {
    DialogFormPregunta: () =>
      import("../disenarEncuesta/DialogFormPregunta"),
    DialogOrdenarPreguntas: () =>
      import("../disenarEncuesta/DialogOrdenarPreguntas"),
    DialogEliminarPregunta: () =>
      import("../disenarEncuesta/DialogEliminarPregunta"),
    RespuestasPregSecEnc: () =>
      import("../disenarEncuesta/RespuestasPregSecEnc"),
    PreguntaSeccionEncuestaContent: () =>
      import("../disenarEncuesta/PreguntaSeccionEncuestaContent"),
  },
  props: {
    idEncuesta: {
      type: Number,
      required: true,
    },
    idSeccion: {
      type: Number,
      required: true,
    },
    loadingProp: {
      type: Boolean,
      default: false
    },
    lstPreguntas: {
      type: Array,
      default: function () {
        return []
      }
    },
    fnSetPreguntas: {
      type: Function,
      default: () => {}
    },
    fnSetRespuestas: {
      type: Function,
      default: () => {}
    }
  },
  data () {
    return {
      loadingPreguntas: false,
      panel: [],
    };
  },
  computed: {
    loadingComp: function () {
      return this.loadingProp || this.loadingPreguntas
    },
    lstGrupos: function () {
      return this.lstPreguntas.filter(n=>n.grupo != '' && n.grupo != null).map(n=>n.grupo).filter((x, i, a) => a.indexOf(x) == i)
    }
  },
  beforeMount () {},
  async mounted () {
  },
  methods: {
    async obtenerPreguntasBySeccion () {

      var self = this;
      self.loadingPreguntas = true;
      var _lstPreguntas = [];

      self.snackbarError = false;
      self.textoError = "";

      try {
        let response = await getPreguntasBySeccion(self.idSeccion);

        if (response.status === 200) {
          if (response.data.flag === true) {
            if (response.data.message === "Consulta correcta") {
              _lstPreguntas = response.data.data;
              self.fnSetPreguntas(this.idSeccion, _lstPreguntas);
            }
          } else {
            self.error = response.data.message;
            self.snackbarTexto = "PreguntasSeccionEncuesta: " + response.data.message;
            self.snackbarColor = "error";
            self.snackbar = true;
          }
        } else {
          self.error = "Error de red";
          self.snackbarTexto = "PreguntasSeccionEncuesta: Error de red";
          self.snackbarColor = "error";
          self.snackbar = true;
        }
        self.loadingPreguntas = false;
      } catch (e) {
        self.loadingPreguntas = false;
        self.error = e;
        self.snackbarTexto = "PreguntasSeccionEncuesta: " + e;
        self.snackbarColor = "error";
        self.snackbar = true;
      }
    },
  }
};
</script>



<style>
.v-stepper__label{
  display: contents!important;
}

.div_btn_inline{
  display:inline;
}
</style>